import { Button } from "@chakra-ui/react";
import { useMemo } from "react";
import { useWatch } from "react-hook-form";

export default function SaveButtonCertification({
  control,
  isDirty,
  onSave,
  validateThemes = false,
  validateLevels = false
}) {
  const pillars = useWatch({ control, name: "form" });

  const isAnyFieldEmpty = useMemo(() => {
    if (!pillars) return true;

    return pillars.some((pillar) => {
      // Always validate pillarName
      const isPillarNameEmpty = !pillar?.pillarName?.trim();
      
      // Validate numberOfThemes if required
      const isThemesEmpty = validateThemes && !pillar?.numberOfThemes?.trim();
      
      // Validate numberOfLevels if required and defined
      const isLevelsEmpty = validateLevels && 
        pillar?.numberOfLevels !== undefined && 
        !pillar?.numberOfLevels?.trim();

      // Return true if any required field is empty
      return isPillarNameEmpty || 
        (validateThemes && isThemesEmpty) || 
        (validateLevels && isLevelsEmpty);
    });
  }, [pillars, validateThemes, validateLevels]);

  return (
    <Button
      aria-label="Salvar"
      variant="primary"
      w="122px"
      size="medium"
      ml="auto"
      onClick={onSave}
      isDisabled={!isDirty || isAnyFieldEmpty}
    >
      Salvar
    </Button>
  );
}